exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#ad[data-v-686debf6]{display:none}@media screen and (min-width:1280px){#ad[data-v-686debf6]{display:block}}", ""]);

// exports
